// Custom js extera

$(document).ready(function(){
	
    // Tab list
    $('ul.ext-tabs li').on('click',function(){
        var tab_id = $(this).attr('data-tab');

        $('ul.ext-tabs li').removeClass('current');
        $('.ext-tab-content').removeClass('current');

        $(this).addClass('current');
        $(".ext-tab-content#" + tab_id).addClass('current');
    });

    // Enable button form with radio
    var privacy_a = '';
    var privacy_b = '';

    // a
    $('form input#privacy_policy_a').on('change click',function() {
        if($(this).val() == 'si'){
            privacy_a = 'ok';                
        }else{
            privacy_a = '';                
        }
    });

    // b
    $('form input#privacy_policy_b').on('change click',function() {
        if($(this).val() == 'si'){
            privacy_b = 'ok';                
        }else{
            privacy_b = '';                
        }
    });

    // general
    $('form input').change(function () {
        if( privacy_a == 'ok' && privacy_b == 'ok' ){
            $(".button__submit").prop("disabled", false);
        }else{
            $(".button__submit").prop("disabled", true);
        }    
    });    
});